/**
 * Detects the mode based on subdomain and query parameters
 * @returns 'dark' if subdomain is 'dark' or query parameter mode=dark, otherwise 'light'
 */
export const detectMode = (): 'light' | 'dark' => {
  // Check for subdomain
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  if (subdomain === 'dark') {
    return 'dark';
  }

  // Check for query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const modeParam = urlParams.get('mode');

  if (modeParam === 'dark') {
    return 'dark';
  }

  // Default to light mode
  return 'light';
};
